import { useEffect } from "react";
import { Link } from "wouter";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useBreadcrumbTrail, type BreadcrumbPage } from "../lib/breadcrumbTrail";

/** Shared desktop/mobile trail: admins return to Listings; members retain their browse/detail journey. */
export function DetailBreadcrumb({ title, fallback, className = "" }: {
  title: string;
  fallback: BreadcrumbPage;
  className?: string;
}) {
  const { user } = useAuth();
  const isAdmin = user?.userType === "admin";
  const trail = useBreadcrumbTrail();
  const nameCurrentPage = trail?.nameCurrentPage;
  useEffect(() => {
    nameCurrentPage?.(title, { href: fallback.href, label: fallback.label });
  }, [nameCurrentPage, title, fallback.href, fallback.label]);
  const parents = isAdmin ? [{ href: "/admin?tab=listings", label: "Back to listings" }]
    : trail?.parents.length ? trail.parents : [fallback];

  return <nav aria-label="Breadcrumb" className={`min-w-0 text-mut ${className}`}>
    <ol className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
      {parents.map((page) => <li key={page.href} className="flex min-w-0 max-w-full items-center gap-2">
        <Link href={page.href} title={page.label} className="inline-flex min-w-0 items-center gap-1.5 hover:text-navy focus-visible:outline focus-visible:outline-2 focus-visible:outline-navy">{isAdmin && <ArrowLeft className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}<span className="min-w-0 truncate">{page.label}</span></Link>
        <ChevronRight className="h-3 w-3 shrink-0" aria-hidden="true" />
      </li>)}
      <li className="min-w-0 max-w-full"><strong aria-current="page" title={title} className="block truncate text-navy">{title}</strong></li>
    </ol>
  </nav>;
}
